import { t } from "../../../core/i18n/i18n";

export enum TreeBlockType {
  DESTINATION = "destination",
  EN_ROUTE_DESTINATION = "enRouteDestination",
  MESSAGE = "message",
  EN_ROUTE_MESSAGE = "enRouteMessage",
  HUNTING_GROUP = "huntingGroup",
  RELEASE_CALL = "releaseCall",
  RELEASE_CALL_PRO = "releaseCallPro",
  SUB_TREE = "subtree",
  IVR_MENU = "ivrMenu",
  DAY_OF_WEEK = "dayOfWeek",
  CALENDAR_DAY_TYPE = "calendarDayType",
  TIME_OF_DAY = "timeOfDay",
  STANDARD_IVR = "standardIvr",
  NUMERIC_CODE = "numericCode",
  GEOGRAPHIC_GROUP = "geographicGroup",
  TRAFFIC_DISTRIBUTION = "trafficDistribution",
  REGISTRATION_COUNTER = "registrationCounter",
  CLIP_PRESENTATION = "presentation",
  ADVANCED_CONDITIONS = "advancedConditions",
  EXT_APP_DESTINATION = "extAppDestination",
  EXT_APP_BRANCH = "extAppBranch",
  INPUT_DESTINATION = "inputDestination",
  NETWORK_OPERATOR = "networkOperator",
  ROOT = "ROOT"
}

export const TreeBlockTypesWithLabels = [
  {
    label: t("hns:tree:treeBlock:destination"),
    value: TreeBlockType.DESTINATION
  },
  {
    label: t("hns:tree:treeBlock:enRouteDestination"),
    value: TreeBlockType.EN_ROUTE_DESTINATION
  },
  { label: t("hns:tree:treeBlock:message"), value: TreeBlockType.MESSAGE },
  {
    label: t("hns:tree:treeBlock:enRouteMessage"),
    value: TreeBlockType.EN_ROUTE_MESSAGE
  },
  {
    label: t("hns:tree:treeBlock:huntingGroup"),
    value: TreeBlockType.HUNTING_GROUP
  },
  {
    label: t("hns:tree:treeBlock:releaseCall"),
    value: TreeBlockType.RELEASE_CALL
  },
  {
    label: t("hns:tree:treeBlock:releaseCallPro"),
    value: TreeBlockType.RELEASE_CALL_PRO
  },
  { label: t("hns:tree:treeBlock:subtree"), value: TreeBlockType.SUB_TREE },
  { label: t("hns:tree:treeBlock:ivrMenu"), value: TreeBlockType.IVR_MENU },
  {
    label: t("hns:tree:treeBlock:dayOfWeek"),
    value: TreeBlockType.DAY_OF_WEEK
  },
  {
    label: t("hns:tree:treeBlock:calendarDayType"),
    value: TreeBlockType.CALENDAR_DAY_TYPE
  },
  {
    label: t("hns:tree:treeBlock:timeOfDay"),
    value: TreeBlockType.TIME_OF_DAY
  },
  {
    label: t("hns:tree:treeBlock:standardIvr"),
    value: TreeBlockType.STANDARD_IVR
  },
  {
    label: t("hns:tree:treeBlock:numericCode"),
    value: TreeBlockType.NUMERIC_CODE
  },
  {
    label: t("hns:tree:treeBlock:geographicGroup"),
    value: TreeBlockType.GEOGRAPHIC_GROUP
  },
  {
    label: t("hns:tree:treeBlock:trafficDistribution"),
    value: TreeBlockType.TRAFFIC_DISTRIBUTION
  },
  {
    label: t("hns:tree:treeBlock:registrationCounter"),
    value: TreeBlockType.REGISTRATION_COUNTER
  },
  {
    label: t("hns:tree:treeBlock:clipPresentation"),
    value: TreeBlockType.CLIP_PRESENTATION
  },
  {
    label: t("hns:tree:treeBlock:advancedConditions"),
    value: TreeBlockType.ADVANCED_CONDITIONS
  },
  {
    label: t("hns:tree:treeBlock:extAppDestination"),
    value: TreeBlockType.EXT_APP_DESTINATION
  },
  {
    label: t("hns:tree:treeBlock:extAppBranch"),
    value: TreeBlockType.EXT_APP_BRANCH
  },
  {
    label: t("hns:tree:treeBlock:inputDestination"),
    value: TreeBlockType.INPUT_DESTINATION
  },
  {
    label: t("hns:tree:treeBlock:networkOperator"),
    value: TreeBlockType.NETWORK_OPERATOR
  }
];

export enum TreeBlockServiceProfile {
  T_BLOCK_ADVANCED_CONDITIONS = "tBlockAdvancedConditions",
  T_BLOCK_CALENDAR_DAY_TYPE = "tBlockCalendarDayType",
  T_BLOCK_DAY_OF_WEEK = "tBlockDayOfWeek",
  T_BLOCK_DESTINATION = "tBlockDestination",
  T_BLOCK_ER_DESTINATION = "tBlockERDestination",
  T_BLOCK_ER_MESSAGE = "tBlockERMessage",
  T_BLOCK_EXT_APP_BRANCH = "tBlockExtAppBranch",
  T_BLOCK_EXT_APP_DESTINATION = "tBlockExtAppDestination",
  T_BLOCK_GEOGRAPHIC_GROUP = "tBlockGeographicGroup",
  T_BLOCK_HUNTING_GROUP = "tBlockHuntingGroup",
  T_BLOCK_INPUT_DESTINATION = "tBlockInputDestination",
  T_BLOCK_IVR_MENU = "tBlockIvrMenu",
  T_BLOCK_MESSAGE = "tBlockMessage",
  T_BLOCK_NUMERIC_CODE = "tBlockNumericCode",
  T_BLOCK_PRESENTATION = "tBlockPresentation",
  T_BLOCK_REGISTRATION_COUNTER = "tBlockRegistrationCounter",
  T_BLOCK_RELEASE = "tBlockRelease",
  T_BLOCK_RELEASE_PRO = "tBlockReleasePro",
  T_BLOCK_STANDARD_IVR = "tBlockStandardIvr",
  T_BLOCK_SUB_TREE = "tBlockSubTree",
  T_BLOCK_TIME_OF_DAY = "tBlockTimeOfDay",
  T_BLOCK_TRAFFIC = "tBlockTraffic",
  T_BLOCK_NETWORK_OPERATOR = "tBlockNetworkOperator",
  ROOT = "ROOT"
}
